<div class="page-header">
	<h1 class="page-title">Role List</h1>
	<div class="page-actions">
		<a [routerLink]="['/role','new']" class="btn btn-primary">Add Role</a>
	</div>
</div>
<div class="row mt-3">
	<div class="col">
		<app-table
			[downloadHeading]="'Role List'"
			[downloadName]="'role_list'"
			[data]="results"
			[headerClass]="'table-info'"
			[columns]="columnRef"
			[filters]="[]"
			[loading]="loading"
			(onRowClick)="open($event)"
			(onUpdateRequired)="doFetchResults($event)"
			>
		</app-table>
	</div>
</div>
